import { cacheDom } from "../utils/QuerySelectors.js"
import { getXgenProducts } from '../utils/Product.js'

const dom = {}
const qs = {
}
const qsAll = {
  sections: 'data-section-type="tab-products"',
  triggers: 'data-tab-trigger',
  tabs: 'data-tab-swiper',
}

const swiperOptions = {
  slidesPerView: 1.5,
  spaceBetween: 12,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    init: function () {
      const swatInterval = setInterval(() => {
        if (typeof window._swat != 'undefined' && window._swat && window._swat.initializeActionButtons) {
          clearInterval(swatInterval)
          setTimeout(() => {
            window._swat.initializeActionButtons('.tab-products', '[data-swaction]')
          }, 500)
        }
      }, 300)
    },
  },
}

const initSlider = (tab, json) => {
  new Swiper(tab, Object.assign(swiperOptions, {
    breakpoints: {
      320: {
        slidesPerView: json.mobile + 0.5,
        spaceBetween: 12,
      },
      768: {
        slidesPerView: json.tablet + 0.5,
      },
      1024: {
        slidesPerView: json.desktop + 0.5,
        spaceBetween: 16,
      },
      1440: {
        slidesPerView: json.large + 0.5,
        spaceBetween: 16,
      },
    }
  }))
}

const initTab = (tab, json) => {
  const xgenId = tab.getAttribute('data-xgen')
  const excludeSale = tab.getAttribute('data-exclude-sale')
  if(xgenId) {
    if(typeof getXgenPredictions != 'undefined') {
      getXgenPredictions(xgenId).then((results) => {
        const skus = results.map((result) => result.variants[0].sku).filter(Boolean)
        getXgenProducts((results) => {
          const swiperWrapper = tab.querySelector('.swiper-wrapper')
          const filteredResults = excludeSale == "true" ? results.filter((result) => !result.tags.includes('Sale') && !result.tags.includes('Final Sale')) : results
          filteredResults.forEach(result => {
            result.related = true
            swiperWrapper.innerHTML +=  `
              <div class="swiper-slide">
                <div class="h-full" product-tile props='${JSON.stringify(result).replaceAll("'", "’")}'></div>
              </div>
            `
          })
          window.setupProductTiles(swiperWrapper.querySelectorAll('[product-tile]:empty'))
          initSlider(tab, json)
        }, skus)
      })
    }
  } else
    initSlider(tab, json)
}

const initSection = (section) => {
  const triggers = section.querySelectorAll(`[${qsAll.triggers}]`)
  const tabs = section.querySelectorAll(`[${qsAll.tabs}]`) 
  const json = JSON.parse(section.querySelector('[type="application/json"]').innerHTML)
  triggers.forEach(trigger => {
    trigger.addEventListener('click', () => {
      triggers.forEach(t => {
        t.classList.toggle('opacity-50', trigger != t)
        t.classList.toggle('underline', trigger == t)
      })
      const blockId = trigger.getAttribute('data-tab-trigger')
      tabs.forEach(tab => tab.classList.toggle('!hidden', tab.getAttribute('data-id') != blockId))
    })
  })

  tabs.forEach(tab => {
    initTab(tab, json)
  })
}

export const setupTabProducts = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    initSection(section)
  })
}